'use strict';

var $ = require('jquery');
var urls = require('shared/scripts/modules/utils/urls');
var transactionStage = require('../transactionStage');

function renderSecondaryBreadCrumbs() {
    var $breadcrumbSecondary_element = $('.breadcrumb-secondary .element');
    if($breadcrumbSecondary_element.length === 2) {
        $('.breadcrumb-secondary').css('width', '212px');
    }

    var hasCurrent = $('.breadcrumb-secondary .element.current').length > 0;
    var prev = null;
    $breadcrumbSecondary_element.each(function(){
        if(prev !== null) {
            var currentPos = $(this).offset().left + $(this).width()/2;
            var prevPos = prev.offset().left + prev.width()/2;
            var width = currentPos - prevPos;
            $(this).find('.line').css({'width': width, 'right': $(this).width()/2});
        }
        prev = $(this);

        if(hasCurrent) {
            $(this).addClass('active');
        }

        if($(this).hasClass('current')) {
            hasCurrent = false;
        }
    });
}

function init(props) {
    renderSecondaryBreadCrumbs();
    $(window).resize(function(){
        renderSecondaryBreadCrumbs();
    });
    initOnDataChange();

    setAccessibleByTransactionStage(props.sessionTransactionStage);

}

function setAccessibleByTransactionStage(stage) {

    var index = transactionStage.indexOf(stage);

    function render(element) {
        var elementId = element.attr('data-id');
        var elementIndex = transactionStage.indexOf(elementId);
        
        if(elementIndex > index) {
            return false;
        }

        element.addClass('navi');            
        if(stage === elementId) {
            return false;
        }

        return true;
    }

    // Set accessible primary breadcrumb
    $('.breadcrumb-primary .element').each(function(){
        if(!render($(this))) { 
            return false;
        }
    });
    // Set accessible secondary breadcrumb
    $('.breadcrumb-secondary .element').each(function(){
        if(!render($(this))) { 
            return false;
        }
    });
}

$('.breadcrumb-primary .element a, .breadcrumb-secondary .element a').click(function(e){
    e.preventDefault();
    //Prevent users to be able to navigate to link if not allowed
    var parent = $(this).parent('.element');
    if((!parent.hasClass('active') && !parent.hasClass('navi')) || parent.hasClass('current')) {
        return false;
    }

    //Append parameters if present
    var href = $(this).attr('href');

    if(urls.getAllUrlParameters()) {
        if(href.indexOf('?') !== -1) {
            href += '&';
        } else {
            href += '?';
        }
        href += urls.getAllUrlParameters();
    }
    urls.navigateToUrl(href);
    
});

function initOnDataChange() {
    $('.journey-container')
        .on('input', 'input', clearForwardLinks)
        .on('change', 'select', clearForwardLinks)
        .on('click', 'input[type="radio"]', clearForwardLinks)
        .on('click', 'input[type="checkbox"]', clearForwardLinks)
        .on('change', '.datepicker', clearForwardLinks);

    $('body').on('click', '.carousel .add-people-checkbox', clearForwardLinks);
}

function clearForwardLinks() {

    //attribute will be used to indicate that user has made a data change on the form.
    //Will be used to decide whether to POST or forward to next page in scenario
    //where they have navigated backwards in the journey
    $('.journey-container').attr('data-changed', true);

    var primaryNav = true;
    $('.breadcrumb-primary .element').each(function(){
        if(primaryNav && $(this).hasClass('current')) {
            primaryNav = false;
        } else if(!primaryNav) {
            $(this).removeClass('navi');
        }
    });

    var secondaryNav = true;
    $('.breadcrumb-secondary .element').each(function(){
        if(secondaryNav && $(this).hasClass('current')) {
            secondaryNav = false;
        } else if(!secondaryNav) {
            $(this).removeClass('navi');
        }
    });
}

module.exports = {
    init: init,
    clearForwardLinks: clearForwardLinks,
    setAccessibleByTransactionStage: setAccessibleByTransactionStage,
};



//////////////////
// WEBPACK FOOTER
// ./src/international/scripts/utils/breadCrumb.js
// module id = Dh8f
// module chunks = 0 1 2 3 5 6